import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles(() => {
  return {
    emailContainer: {
      padding: "34px 20px 20px 20px"
    },
    warning: {
      display: "flex",
      borderRadius: "6px",
      padding: "8px",
      backgroundColor: "#e4effb"
    },
    headerContainer: {
      padding: "0px 20px",
      alignItems: "center"
    },
    dropdown: {
      height: "30px",
      color: "#0259cc",
      borderRadius: "6px"
    },
    divider: {
      borderBottom: "1px solid #e1e8ee",
      margin: "15px 0"
    },
    headerLabel: {
      "&.MuiTypography-root": {
        fontSize: "24px",
        fontWeight: "600",
        textAlign: "center",
        marginTop: "20px"
      }
    },
    dateContainer: {
      fontSize: "14px",
      margin: "36px 0 10px 0"
    },
    dateLabel: {
      opacity: "0.5",
      marginRight: "10px"
    },
    toContainer: {
      padding: "16px 20px",
      display: "flex",
      alignItems: "center"
    },
    toLabel: {
      fontSize: "14px",
      opacity: "0.5",
      marginRight: "22px"
    },
    emailLabel: {
      backgroundColor: "#e1e8ee",
      borderRadius: "3px",
      padding: "3px 6px",
      fontSize: "10px",
      marginRight: "8px"
    },
    subjectContainer: {
      fontSize: "14px"
    },
    subjectLabel: {
      opacity: "0.5",
      marginRight: "20px"
    },
    tableContainer: {
      margin: "16px 20px",
      border: "1px solid #e1e8ee"
    },
    termSheetTableContainer: {
      border: "1px solid #e1e8ee"
    },
    tableLabel: {
      backgroundColor: "#f2f6ff",
      paddingLeft: "10px",
      alignItems: "center",
      fontSize: "14px"
    },
    tableValue: {
      paddingLeft: "10px",
      fontSize: "14px",
      padding: "8px",
      alignItems: "center"
    },
    requirementContiner: {
      margin: "20px 20px",
      display: "flex",
      "&.MuiGrid-root": {
        flexDirection: "column"
      }
    },
    requirementTitle: {
      fontSize: "14px",
      fontWeight: "bold",
      color: "#000",
      paddingBottom: "10px"
    },
    requirementInputBox: {
      "&.MuiFormControl-root": {
        paddingTop: "10px"
      },
      "& .MuiInputBase-root": {
        height: "36px",
        "& .MuiInputBase-input": {
          textOverflow: "ellipsis"
        }
      }
    },
    verticalDivider: {
      display: "inline-block",
      width: "1px",
      backgroundColor: "#b9bcd1",
      margin: "0 10px",
      height: "36px"
    },
    requirementBtn: {
      // width: "142px",
      "&.MuiButton-root": {
        marginTop: "20px",
        borderRadius: "6px"
      }
    },
    footerContainer: {
      padding: "0px 20px"
    },
    customTextField: {
      "& .MuiOutlinedInput-root": {
        minHeight: "36px",
        "& .MuiInputBase-input": {
          padding: "8.5px 14px"
        },
        "& .MuiOutlinedInput-notchedOutline": {
          borderColor: "#dcdcdc"
        }
      }
    },
    adornmentWrapper: {
      display: "flex",
      alignItems: "center",
      border: "1px solid #dcdcdc",
      borderRadius: "4px 0 0 4px"
    },
    labelBox: {
      display: "flex",
      alignItems: "center",
      paddingRight: "8px"
    },
    verticalBar: {
      borderLeft: "1px solid #dcdcdc",
      height: "24px",
      marginLeft: "8px",
      marginRight: "8px"
    }
  };
});
